const APPROVED_ORDER_STATUSES = new Set(['approved', 'delivered', 'completed']);

export const normalizeOrderItemsForAccess = (order = {}) => {
  const rawItems = order.Items || order.items || order.orderDetails || [];
  if (Array.isArray(rawItems)) return rawItems.filter(Boolean);
  if (rawItems && typeof rawItems === 'object') return Object.values(rawItems).filter(Boolean);
  return [];
};

const getOrderStatus = (order = {}) => String(order.Status || order.status || '').trim().toLowerCase();

const isApprovedPaidOrder = (order = {}) => APPROVED_ORDER_STATUSES.has(getOrderStatus(order));

const isAddonItem = (item = {}) => (
  item.itemType === 'addon' || Boolean(item.addonId || item.addonFor)
);

const isExtensionItem = (item = {}) => (
  item.itemType === 'extension' ||
  Boolean(item.extensionFor || item.ExtensionFor) ||
  String(item.category || '').toLowerCase() === 'extension'
);

const getItemProductId = (item = {}) => String(
  item.productId ||
  item.ProductId ||
  item.id ||
  ''
).replace(/-extension$/, '').trim();

export const hasDirectPaidProductOrder = (orders = [], productId, { includeExtensions = true } = {}) => {
  const targetProductId = String(productId || '').trim();
  if (!targetProductId || !Array.isArray(orders)) return false;

  return orders.some((order) => {
    if (!isApprovedPaidOrder(order)) return false;
    return normalizeOrderItemsForAccess(order).some((item) => {
      if (!item || isAddonItem(item)) return false;
      if (!includeExtensions && isExtensionItem(item)) return false;
      return getItemProductId(item) === targetProductId;
    });
  });
};

export const isExtensionDiscountEligibleAccess = ({ productId, accessRecord = null, orders = [] }) => {
  const targetProductId = String(productId || '').trim();
  if (!targetProductId) return false;

  const directPaidOrderExists = hasDirectPaidProductOrder(orders, targetProductId, {
    includeExtensions: true
  });
  if (directPaidOrderExists) return true;

  const orderId = String(accessRecord?.orderId || '').trim().toUpperCase();
  const source = String(accessRecord?.source || accessRecord?.lastAdjustment?.source || '').trim().toLowerCase();
  if (orderId.startsWith('MANUAL_') || source.startsWith('manual')) return false;

  return false;
};

export const shouldApplyExtensionDiscount = (item = {}) => (
  Boolean(item.extensionDiscountEligible) && !item.renewal
);
